import React from "react";
import { withRouter } from "react-router-dom";
import {
  LoginPageStyled,
  BlockLoginStyled,
  KeyButtonStyledBack,
  KeyButtonStyledNext,
  ButtonsGroupStyled,
  HeadingStyled,
  ContainerStyled,
  TextStyled,
  ProfileImage,
  ProfileImageContainer,
  ImageAndInputBlockStyled,
  InputContainerStyled,
  InputStyled,
  LogoStyled
} from "./styles/Styled";
import { Input, KeyboardSwap, withFocusable } from "../../services/visualLibraryService";
import { withAppState } from "../../state";
import { i18n } from "../../services/i18nService";
import { withSubtheme } from "../../styles/themes/withSubtheme";
import { redirectTo } from "../../services/navigationService";
import { historyMethods } from "../../utils/historyMethods";
import { trimSpacesBeforeFirstLetter } from "../../utils/replaceText";
import { routes } from "../../routes";
import FreeLogo from "../../components/FreeLogo";
import { getAllProfiles, onEditProfile } from "../../services/multipleProfilesService";
import { getGlobalButtonInfo, getGlobalButtonFocusPath } from "../../errors/globalButtons";
import { showSaveProfileChangesModal } from "../../utils/multiProfileModalUtils";
import { showMultipleProfileErrorModal } from "../../services/modalsService";
import { trackEvent } from "../../services/analyticsService";

const KeyButtonStyledBackFocus = withFocusable(KeyButtonStyledBack);
const KeyButtonStyledNextFocus = withFocusable(KeyButtonStyledNext);

const PROFILE_NAME_MAX_LENGTH = 12;

class ProfileName extends React.Component {
  constructor(props) {
    super(props);
    this.userInput = React.createRef();
    this.state = {
      initialprofileNameInputValue: "",
      profileNameInputValue: "",
      avatar: "",
      isFromAddProfile: false,
      isKeyboardVisited: false
    };
    this.updateValue = this.updateValue.bind(this);
    this.keyboardDidSwap = this.keyboardDidSwap.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onClickContinue = this.onClickContinue.bind(this);
    this.onBack = this.onBack.bind(this);
    this.setProfileData = this.setProfileData.bind(this);
    this.showErrorIfNameExists = this.showErrorIfNameExists.bind(this);
    this.onSaveChanges = this.onSaveChanges.bind(this);
    this.onDiscardChanges = this.onDiscardChanges.bind(this);

    this.mounted = false;
    this.isModalOpen = false;
    this.isSaveChangesModalOpen = false;
  }

  async setProfileData() {
    const { history } = this.props;
    const hasHistoryState = !!(history.location && history.location.state);
    const profileName = history.location && history.location.state && history.location.state.profileName;
    const avatar = history.location && history.location.state && history.location.state.avatar;
    const isFromAddProfile = history.location && history.location.state && history.location.state.isFromAddProfile;
    if (hasHistoryState) {
      this.setState({
        avatar: avatar,
        profileNameInputValue: profileName,
        isFromAddProfile: isFromAddProfile,
        initialprofileNameInputValue: profileName
      });
    }
  }

  componentDidMount() {
    const { onRef } = this.props;
    onRef && onRef(this);
    this.mounted = true;
    this.setProfileData();
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.currentFocus !== this.props.currentFocus ||
      nextState.profileNameInputValue !== this.state.profileNameInputValue
    );
  }

  closeModal() {
    this.props.stateActions.hideGlobalModal();
    this.props.setFocus(KeyboardSwap.defaultFocusPath);
  }

  updateValue(name) {
    const value = trimSpacesBeforeFirstLetter(name);
    if ((value && value.length) > PROFILE_NAME_MAX_LENGTH) {
      return;
    }
    this.setState({ profileNameInputValue: value, isKeyboardVisited: true });
  }

  checkLoginButtonDisability() {
    if (!this.state.isKeyboardVisited || this.state.profileNameInputValue === this.state.initialprofileNameInputValue) {
      return true;
    } else {
      return (
        !(this.state.profileNameInputValue && this.state.profileNameInputValue.length) ||
        this.state.profileNameInputValue.length > PROFILE_NAME_MAX_LENGTH
      );
    }
  }

  async onClickContinue(isToCheckChanges = null) {
    const { history } = this.props;
    const { isFromAddProfile } = this.state;
    const hasHistoryState = !!(history.location && history.location.state);
    try {
      if (hasHistoryState && history.location.state.backDestination) {
        const backDestination = history.location.state.backDestination;
        const profileData = history.location.state.profileData;
        const oldProfileData = history.location.state.oldProfileData;
        const isCallEditAPI = isToCheckChanges ? isToCheckChanges : history.location.state.isCallEditAPI || false;
        const profileName = trimSpacesBeforeFirstLetter(this.state.profileNameInputValue);
        const isUserChangeProfileName = profileName !== profileData.profileName ? true : false;
        const isNameExist = await this.showErrorIfNameExists();
        if (isNameExist) {
          return;
        }
        let backDestinationPathname = backDestination.pathname || backDestination;

        if (isCallEditAPI) {
          const updatedProfileData = await onEditProfile.call(this, {
            profileName: profileName,
            profileId: profileData.profileId,
            isMasterProfile: profileData.isMasterProfile
          });
          const updatedProfile = {
            location: this.isSaveChangesModalOpen ? "back discard popup" : "manage profile screen",
            isProfileNameChange: !!(profileData?.profileName !== profileName)
          };
          trackEvent("profile_settings_updated", null, "MP", {
            profileData: { updatedProfileId: updatedProfileData?.profileId, ...updatedProfileData },
            updatedProfile
          });
          profileData.profileName = profileName;
        }
        let stateObj = {};
        if (isFromAddProfile) {
          backDestinationPathname = routes.addProfile;
          stateObj = {
            profileData: { avatar: this.state.avatar, profileName: profileName },
            oldProfileData: oldProfileData
          };
        } else {
          stateObj = { profileName: profileName, isUserChangeProfileName, profileData, oldProfileData };
        }
        this.isSaveChangesModalOpen = false;
        this.closeModal();
        history.replace({
          pathname: backDestinationPathname,
          state: stateObj
        });
      }
    } catch (error) {
      showMultipleProfileErrorModal.call(this, "loginNextButton");
    }
  }

  async showErrorIfNameExists() {
    let isNameExist = false;
    const { stateActions } = this.props;
    let profilesData = await getAllProfiles();
    if (profilesData && profilesData.length > 0) {
      profilesData.forEach(profile => {
        if (profile.profileName === this.state.profileNameInputValue) {
          // show error popup if name already exists
          stateActions.showGlobalModal({
            modalText: i18n.get(`global.errors.multiProfile.profileNameErrorText`),
            buttons: [
              {
                ...getGlobalButtonInfo("close"),
                buttonHandler: this.closeModal
              }
            ]
          });

          this.props.setFocus(getGlobalButtonFocusPath("close"));
          isNameExist = true;
        }
      });
    }
    return isNameExist;
  }

  async showErrorIfNameNotValid() {
    const { stateActions } = this.props;
    let isProfileNameValid = false;
    // const regex = new RegExp(/^[a-z0-9\-\._ ]+$/i);
    const regex = new RegExp(/^(?=.*[A-Za-z])(?=.*\W)(?!^\d+$).{1,12}$/);
    isProfileNameValid = regex.test(this.state.profileNameInputValue);
    if (!isProfileNameValid) {
      stateActions.showGlobalModal({
        modalText: "Profile Name is not valid",
        buttons: [
          {
            ...getGlobalButtonInfo("close"),
            buttonHandler: this.closeModal
          }
        ]
      });

      this.props.setFocus(getGlobalButtonFocusPath("close"));
    }

    return isProfileNameValid;
  }

  keyboardDidSwap({ defaultFocusPath }) {
    this.props.setFocus(defaultFocusPath);
  }

  async onBack(isToCheckChanges = null) {
    const { history } = this.props;
    const hasHistoryState = !!(history.location && history.location.state);
    if (hasHistoryState && history.location.state.backDestination) {
      const backDestination = history.location.state.backDestination;
      const profileData = history.location.state.profileData;
      const oldProfileData = history.location.state.oldProfileData;
      const backDestinationPathname = backDestination.pathname || backDestination;
      const isToShowPopup = history.location.state.isToShowPopup;
      const isCallEditAPI =
        isToCheckChanges !== null ? isToCheckChanges : history.location.state.isCallEditAPI || false;
      const isUserChangeProfileName =
        !!this.state.profileNameInputValue && this.state.profileNameInputValue !== profileData.profileName
          ? true
          : false;
      if (isCallEditAPI && isUserChangeProfileName && isToShowPopup) {
        this.isSaveChangesModalOpen = true;
        const focusPath = await showSaveProfileChangesModal.call(this, this.onSaveChanges, this.onDiscardChanges);
        this.props.setFocus(focusPath);
        return;
      }
      this.isSaveChangesModalOpen = false;
      history.replace({
        pathname: backDestinationPathname,
        state: { profileData: { ...profileData }, oldProfileData: oldProfileData }
      });
      this.closeModal();
      return true;
    }
    redirectTo.call(this, routes.home, null, historyMethods.REPLACE);
    return true;
  }

  onDiscardChanges() {
    const profileData = this.props.history.location.state.profileData;
    trackEvent("profile_settings_update_discarded", null, "MP", { location: "back discard popup", ...profileData });
    this.onBack(false);
  }

  async onSaveChanges() {
    this.onClickContinue(true);
  }

  render() {
    return (
      <LoginPageStyled>
        <LogoStyled>
          <FreeLogo height={"1.968rem"} />
        </LogoStyled>
        <HeadingStyled fontWeight="semiBold" rank={2} text={i18n.get("pages.profileName.profileNameHeader")} />
        <TextStyled text={i18n.get("pages.profileName.description1")} />
        <ContainerStyled>
          <BlockLoginStyled>
            <KeyboardSwap
              text={this.state.profileNameInputValue}
              onChange={this.updateValue}
              direction={i18n.getDirection()}
              onSwap={this.keyboardDidSwap}
              dataSnUp={""}
              showEmailKeys={false}
            />
            <ButtonsGroupStyled>
              <KeyButtonStyledBackFocus
                onEnterPress={() => this.onBack(null)}
                onClick={() => this.onBack(null)}
                focusPath={"loginBackButton"}
                dataSnLeft={i18n.getDirection() === "ltr" ? "" : "@loginNextButton"}
                label={i18n.get("global.back")}
              ></KeyButtonStyledBackFocus>

              <KeyButtonStyledNextFocus
                onEnterPress={() => this.onClickContinue(false)}
                onClick={() => this.onClickContinue(false)}
                focusPath={"loginNextButton"}
                dataSnLeft={i18n.getDirection() === "rtl" ? "" : "@loginBackButton"}
                label={i18n.get("global.continue")}
                disabled={this.checkLoginButtonDisability()}
                direction={i18n.getDirection()}
              ></KeyButtonStyledNextFocus>
            </ButtonsGroupStyled>
          </BlockLoginStyled>
          <BlockLoginStyled>
            <ImageAndInputBlockStyled>
              <ProfileImageContainer>
                <ProfileImage src={this.state.avatar} />
              </ProfileImageContainer>
              <InputContainerStyled>
                <InputStyled
                  id={"profiler-name"}
                  type="text"
                  ref={this.userInput}
                  value={this.state.profileNameInputValue}
                  readOnly
                  placeholder={i18n.get("pages.profileName.profileNameHeader").toUpperCase()}
                />
              </InputContainerStyled>
            </ImageAndInputBlockStyled>
          </BlockLoginStyled>
        </ContainerStyled>
      </LoginPageStyled>
    );
  }
  // console.log("==> ~ ProfileName ~ render ~ this.props.applicationState.currentFocus:", this.props.applicationState.currentFocus)
}

const ProfileNamePage = withRouter(
  withAppState(
    withSubtheme(({ history, applicationState, stateActions, setFocus, onRef, resumeNavigation, pauseNavigation }) => (
      <ProfileName
        history={history}
        currentFocus={applicationState.currentFocus}
        stateActions={stateActions}
        setFocus={setFocus}
        voucherData={applicationState.voucherData}
        signupUsername={applicationState.signupUsername}
        onRef={onRef}
        applicationState={applicationState}
        resumeNavigation={resumeNavigation}
        pauseNavigation={pauseNavigation}
      />
    ))
  )
);

ProfileNamePage.defaultFocusPathLTR = KeyboardSwap.defaultFocusPathLTR;
ProfileNamePage.defaultFocusPathRTL = KeyboardSwap.defaultFocusPathRTL;
ProfileNamePage.defaultFocusPath = KeyboardSwap.defaultFocusPath;

export default ProfileNamePage;
